import React, { useContext, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { HealthReportsTable } from './sections/HealthReportsTable/HealthReportsTable';
import MonthlyReportsTable from './sections/MonthlyReportsTable/MonthlyReportsTable';
import PayrollReportsTable from './sections/PayrollReportsTable/PayrollReportsTable';
import BdsSegment from '../../shared/components/v3/BdsSegment/BdsSegment';
import SecondaryHero from '../../shared/components/v3/Heros/SecondaryHero/SecondaryHero';
import { PLAN_TYPE_FR, PLAN_TYPE_HEALTH } from '../../shared/constants/plan';
import { CompanyContext } from '../../shared/context/company/companyContext';
import { useTabs } from '../../shared/hooks/Reports/useTabs/useTabs';
import { useScrollState } from '../../shared/hooks/useScrollState/useScrollState';
import { TRANSLATIONS_REPORTS } from '../../shared/translations/reports';

import './Reports.scss';

export const Reports = () => {
  const { companyPlansType, isSpain } = useContext(CompanyContext);
  const { t } = useTranslation();
  const isScrolled = useScrollState(0);

  const isRFPlan = useMemo(() => companyPlansType === PLAN_TYPE_FR, [companyPlansType]);

  const isHealthPlan = useMemo(() => companyPlansType === PLAN_TYPE_HEALTH, [companyPlansType]);

  const { tabIndex, tabsItems, onTabChange, shouldShowTabs, showPayrollReports, showHealthReports } = useTabs(
    isRFPlan,
    isHealthPlan
  );

  const heroTitle = useMemo(
    () => (isSpain ? TRANSLATIONS_REPORTS.rf.heroTitle : TRANSLATIONS_REPORTS.default.heroTitle),
    [isSpain]
  );

  const tabs = useMemo(() => {
    return tabsItems.map((tab) => {
      if (tab.id === 1) {
        return isSpain ? t(tab.title) : t(TRANSLATIONS_REPORTS.default.title);
      }
      return t(tab.title);
    });
  }, [tabsItems, t, isSpain]);

  const renderTable = () => {
    if (showPayrollReports) {
      return <PayrollReportsTable />;
    }
    if (showHealthReports) {
      return <HealthReportsTable />;
    }
    return <MonthlyReportsTable />;
  };

  return (
    <div className="reports-page-container flex flex-col" data-experience="new">
      <div className="reports-header">
        <SecondaryHero
          title={isScrolled ? t(heroTitle) : ''}
          description={t(heroTitle)}
          color="hero-collaborators"
          backAction={() => window.history.back()}
        />
        {shouldShowTabs && !isScrolled && (
          <div className="reports-tabs">
            <div className="tabbar flex flex-row">
              <BdsSegment items={tabs} activeIndex={tabIndex} action={onTabChange} fullWidth={true} />
            </div>
          </div>
        )}
      </div>
      <div className="px-12">{renderTable()}</div>
    </div>
  );
};

export default Reports;
